<template>
  <div
    class="upload-outer"
    @click="onClick"
    :style="{ width: width, height: height }"
  >
    <div ref="icon" class="el-icon-upload icon"></div>
    <img
      ref="img"
      class="img"
      :src="imgSrc"
      :style="{ width: width, height: height }"
    />
    <input type="file" ref="uploadFile" @change="onChange" :accept="accept" />
    <span :style="{ display: showTip }" class="tip">{{ tip }}</span>
    <span :style="{ display: showTip }" class="tip2">{{ tip2 }}</span>
  </div>
</template>

<script>
import OSS from "ali-oss";
export default {
  name: "UploadFile",
  props: ["width", "height", "tip", "tip2", "whiteList","accept"],
  data() {
    return {
      imgSrc: "",
      showTip: "block",
      // preUrl: process.env.VUE_APP_UPLOAD_FILE_URL
    };
  },
  methods: {
    onClick() {
      this.$refs.uploadFile.click();
    },
    onUploadSuccees(res) {
      this.imgSrc = res.url;
      this.$refs.img.style.display = "block";
      this.$refs.icon.style.display = "none";
      this.showTip = "none";
      this.$refs.uploadFile.value = "";
      this.$emit("onSucceed", res.url);
    },
    OnShow(imgSrc) {
      // if (!imgSrc) {
      //   return;
      // }
      this.imgSrc = imgSrc;
      this.$refs.img.style.display = "block";
      this.$refs.icon.style.display = "none";
      this.showTip = "none";
    },
    OnHide() {
      this.$refs.img.style.display = "none";
      this.$refs.icon.style.display = "block";
      this.showTip = "block";
    },
    GetImgUrl() {
      return this.imgSrc;
    },
    onChange() {
      if (this.whiteList && this.whiteList.length > 0) {
        let file = this.$refs.uploadFile.files[0].name;

        var path = file.split(".");

        var suffix = path[path.length - 1];

        if (this.whiteList.indexOf(suffix) <= -1) {
          this.$message.error(
            "文件格式错误，只支持:" + this.whiteList.join(",")
          );
          return;
        }
      }

      this.$api.storage.ApplySecurityToken().then((res) => {
        let data = res.data;
        let file = this.$refs.uploadFile.files[0];

        let client = new OSS({
          region: data.region,
          //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          stsToken: data.securityToken,
          bucket: data.bucket,
        });
        let fileName = data.dir + "/" + new Date().getTime() + "/" + file.name;
        client
          .put(fileName, file)
          .then((r1) => {
            r1.url = r1.url.replace("http:", "https:");
            // r1.url = this.preUrl + '/' + fileName;
            this.onUploadSuccees(r1);
          })
          .catch((err) => {
            console.error("error: %j", err);
          });
      });
    },
    uploadFile() {},
  },
};
</script>
<style >
.upload-outer {
  display: inline-block;
  position: relative;
  width: 200px;
  height: 120px;
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
}
.upload-outer .tip {
  position: absolute;
  display: inline-block;
  bottom: 61px;
  left: 50%;
  transform: translate(-50%);
  font-size: 14px;
  color: #666666;
}
.upload-outer .tip2 {
  position: absolute;
  display: inline-block;
  bottom: 32px;
  left: 50%;
  transform: translate(-50%);
  font-size: 14px;
  color: #666666;
}
.upload-outer .icon {
  position: absolute;
  left: 50%;
  top: 38px;
  margin-left: -34px;
  width: 67px;
  height: 67px;
  font-size: 67px;
  color: #409eff;
}
.upload-outer input {
  display: none !important;
}
.upload-outer .img {
  width: 100%;
  height: 100%;
  display: none;
}
</style>